import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import {
  CLEAR_ACTION_ITEM_CATEGORY_STATE,
  FETCH_ACTION_ITEM_CATEGORY_LIST_PROGRESS,
  FETCH_ACTION_ITEM_CATEGORY_LIST_SUCCESS,
  FETCH_ACTION_ITEM_CATEGORY_LIST_FAILED,
} from "./ActionItemCategoryActions";

import { initialActionItemCategories } from "./defaultState";
import { IActionItemCategories } from "./ActionItemCategory.types";
import { ActionItemCategoryActions } from ".";

export const actionItemCategoriesReducer = (
  state: IStoreState["actionItemCategories"] = initialActionItemCategories,
  action: ActionItemCategoryActions,
) => {
  switch (action.type) {
    case FETCH_ACTION_ITEM_CATEGORY_LIST_PROGRESS: {
      const newState = produce(state, (draftState: IActionItemCategories) => {
        draftState.list.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_ACTION_ITEM_CATEGORY_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState: IActionItemCategories) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.data = data;
        draftState.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_ACTION_ITEM_CATEGORY_LIST_FAILED: {
      const newState = produce(state, (draftState: IActionItemCategories) => {
        draftState.list.loading = LoadState.Failed;
      });
      return newState;
    }
    case CLEAR_ACTION_ITEM_CATEGORY_STATE: {
      return initialActionItemCategories;
    }
    default:
      return state;
  }
};
